import configureStore from './configureStore';

const configure = configureStore();

export const { store, persistor } = configure;

if (process.env.ENV === 'dev' || process.env.ENV === 'local') {
  window.clear = () => {
    persistor.purge();
    window.localStorage.clear();
  };
}
